module.exports = __webpack_public_path__ + "static/img/versionBackground.30678b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hhypc/versionBackground.png
// module id = 9fSb
// module chunks = 230